import { Link } from 'react-router-dom';
import { ERIS_Screen } from 'src/ui/eris/router/ErisScreen';
import { ErisScreensMap } from 'src/ui/eris/router/ErisScreenMap';
import { buildErisPath } from 'src/ui/eris/router/ErisScreensRegistration';

interface LinkButtonProps {
  screen: ERIS_Screen;
  className?: string;
  params?: Record<string, string>;
  label: string;
}

export const LinkButton = ({ screen, className, params, label }: LinkButtonProps) => {
  let path = ErisScreensMap[screen].path;

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      path = path.replace(`:${key}`, value);
    });
  }

  return (
    <Link
      to={buildErisPath(path)}
      className={`p-1 text-sm font-semibold text-blue-600 visited:bg-purple-600 visited:text-purple-600 hover:underline ${className}`}
    >
      {label}
    </Link>
  );
};
